import { compactTranscriptFingerprint } from "./transcriptVersion";
import { validatePostSessionProvenance } from "./postSessionProvenance";

function normalizeText(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function normalizeCompletedAt(value) {
  const parsed = Date.parse(String(value || ""));
  return Number.isFinite(parsed) ? new Date(parsed).toISOString() : "";
}

export function hasMeaningfulCompletionTranscript(messages = []) {
  const sourceMessages = Array.isArray(messages) ? messages : [];
  const userTurnCount = sourceMessages.filter((message) => {
    const role = normalizeText(message?.role || message?.sender).toLowerCase();
    return role !== "assistant" &&
      role !== "nia" &&
      normalizeText(message?.content || message?.text);
  }).length;
  return sourceMessages.length >= 5 && userTurnCount >= 2;
}

export function buildSessionCompletionVersion({
  orgId,
  userId,
  sessionId,
  messages = [],
  completedAt,
} = {}) {
  const safeOrgId = normalizeText(orgId);
  const safeUserId = normalizeText(userId);
  const safeSessionId = normalizeText(sessionId);
  const safeCompletedAt = normalizeCompletedAt(completedAt);
  const sourceMessages = Array.isArray(messages) ? messages : [];
  if (
    !safeOrgId ||
    !safeUserId ||
    !safeSessionId ||
    !safeCompletedAt ||
    !hasMeaningfulCompletionTranscript(sourceMessages)
  ) {
    return null;
  }
  const transcriptFingerprint = compactTranscriptFingerprint(sourceMessages);
  return {
    id: `completion:v1:${transcriptFingerprint}:${safeCompletedAt}`,
    orgId: safeOrgId,
    userId: safeUserId,
    sessionId: safeSessionId,
    transcriptFingerprint,
    sourceMessageCount: sourceMessages.length,
    completedAt: safeCompletedAt,
  };
}

export function canCreateOwnedCompletion({
  role = "",
  viewerUserId = "",
  sessionUserId = "",
} = {}) {
  const safeRole = normalizeText(role).toLowerCase();
  const safeViewerUserId = normalizeText(viewerUserId);
  const safeSessionUserId = normalizeText(sessionUserId);
  return Boolean(
    safeRole === "member" &&
    safeViewerUserId &&
    safeSessionUserId === safeViewerUserId
  );
}

export function getSessionLifecycleStatus(record = {}) {
  if (validatePostSessionProvenance(record).completionValid) {
    return "completed";
  }
  if (
    record?.sessionComplete === true ||
    record?.sessionCompleted === true ||
    record?.endedAt
  ) {
    return "closed_unverified";
  }
  return "active";
}

export function getSessionLifecycleLabel(record = {}) {
  const status = getSessionLifecycleStatus(record);
  if (status === "completed") return "Completed session";
  if (status === "closed_unverified") return "Closed — completion unverified";
  return "Active session";
}
